import { AuthService } from "./AuthService";
import { ApiService } from "./ApiService";
import { SERVICE_URL } from "../evironment";
import { UiService } from "./UiService";
import { UsersService } from "./UsersService";
import { RolesService } from "./RolesService";
import { FormsServices } from "./FormsServices";
import { FormsFactory } from "./FormsFactory";
import { SectionsFactory } from "./SectionsFactory";
import { QuestionsFactory } from "./QuestionsFactory";
import { InstancesService } from "./InstancesService";
import { QueryParamsFactory } from "./QueryParamsFactory";
import { AnswersService } from "./AnswersService";
import { InstancePdfFactory } from "./InstancePdfFactory";
let sectionsFactory;
const queryParamsFactory = new QueryParamsFactory();
const uiService = new UiService();
const questionsFactory = new QuestionsFactory(() => sectionsFactory);
sectionsFactory = new SectionsFactory(questionsFactory);
const formsFactory = new FormsFactory(sectionsFactory);
const apiService = new ApiService(SERVICE_URL, uiService);
const usersService = new UsersService(apiService);
const authService = new AuthService(apiService);
const rolesService = new RolesService(apiService);
const formsService = new FormsServices(apiService, formsFactory, queryParamsFactory);
const instancesService = new InstancesService(apiService, queryParamsFactory);
const answersService = new AnswersService(apiService, queryParamsFactory);
const instancePdfFactory = new InstancePdfFactory(apiService);
export { uiService, usersService, authService, rolesService, formsService, formsFactory, sectionsFactory, questionsFactory, instancesService, answersService, instancePdfFactory, };
